<template>
    <div>
        <DadosAluno></DadosAluno>
        <PageTitle title="Francesinha" style="margin:20px 0 24px 0" />
        <template v-if="$featureToggle && $featureToggle.INTEGRA_FRANCESINHA">
            <md-field class="circular-input">
                <label>Digite o Nosso Número</label>
                <md-input v-model="campoBuscaRetorno" v-mask="'##############'" @keyup.enter="pesquisa(campoBuscaRetorno)"></md-input>
                <md-icon @click.native="pesquisa(campoBuscaRetorno)">search</md-icon>
            </md-field>
            <Loading v-bind:show="showLoadingTabelaFrancesinha">
                <GridLinha v-if="dadosAba"
                           v-bind:Data="dadosAba"
                           :key="dataKey"
                           v-bind:Header="headerAtivos"
                           Name="francesinha"
                           Title="francesinha">

                </GridLinha>
                <div style="text-align:center;margin-top:15px">
                    <span v-if="dadosAba && dadosAba.length == 0">{{msgErro ? msgErro : "Nenhum dado encontrado."}}</span>
                </div>
            </Loading>
        </template>
        <span v-else class="s-h3 regular">Funcionalidade desabilitada temporariamente</span>
    </div>


</template>
<script>
    import DadosAluno from '@/components/DadosAluno';
    import PageTitle from '@/components/PageTitle';
    import RetornoBancarioService from '@/services/RetornoBancarioService.js';
    import GridLinha from '@/components/GridLinha';
    import Loading from '@/components/Loading';
    import { RemoverZeroAEsquerda, FormatarData, FormataDinheiro } from '@/components/CustomFunctions.js';
    import { mask } from 'vue-the-mask'; //https://vuejs-tips.github.io/vue-the-mask/

    export default {
        name: 'Francesinha',

        data() {
            return {
                showLoadingTabelaFrancesinha: false,
                campoBuscaRetorno: "",
                msgErro: null,
                dataKey: 1,
                headerAtivos: [
                    { Titulo: "Pagador", Field: "pagador", Width: "40px", Tipo: "texto" },
                    { Titulo: "Seu Número", Field: "seuNumero", Width: "40px", Tipo: "texto" },
                    { Titulo: "Nosso Número", Action: (a) => RemoverZeroAEsquerda(a), Field: "nossoNumero", Width: "40px", Tipo: "texto" },
                    { Titulo: "Venc.", Action: (a) => FormatarData(a), Field: "vencimento", Width: "40px", Tipo: "texto" },
                    { Titulo: "Data Pgto", Action: (a) => FormatarData(a), Field: "dataPagamento", Width: "40px", Tipo: "texto" },
                    { Titulo: "Valor do Título ", Action: (a) => FormataDinheiro(a), Field: "valorBoleto", Width: "40px", Tipo: "texto" },
                    { Titulo: "Juros/Mora", Action: (a) => FormataDinheiro(a), Field: "jurosMora", Width: "40px", Tipo: "texto" },
                    { Titulo: "Abat/Desc.", Action: (a) => FormataDinheiro(a), Field: "abatimentosDescontos", Width: "40px", Tipo: "texto" },
                    { Titulo: "Valor Pago", Action: (a) => FormataDinheiro(a), Field: "valorPago", Width: "40px", Tipo: "texto" },
                    { Titulo: "Evento", Field: "evento", Width: "40px", Tipo: "texto" }
                ],
                dadosAba: null
            }
        },

        created() {
            if (!this.$featureToggle || !this.$featureToggle.INTEGRA_FRANCESINHA) {
                this.$modal.alert(this.$msgFeatureToggle ? this.$msgFeatureToggle : "Erro ao carregar feature toggles.");
                return;
            }
            this.retornoBancarioService = new RetornoBancarioService(this);
        },

        components: {
            GridLinha,
            DadosAluno,
            PageTitle,
            Loading
        },
        directives: {
            mask
        },
        methods: {
            async pesquisa(nossoNumero) {
                if (!nossoNumero) {
                    this.dadosAba = null;
                    return;
                }
                this.showLoadingTabelaFrancesinha = true;
                try {
                    let a = await this.retornoBancarioService.BuscarRetornoBancario(nossoNumero);
                    if (a && a.dados) {
                        this.msgErro = null;
                        this.dadosAba = a.dados;
                    }
                } catch (e) {
                    console.log(e);
                    this.msgErro = "Erro ao carregar dados, mensagem disponível em log."
                    this.dadosAba = [];
                } finally {
                    this.showLoadingTabelaFrancesinha = false;
                    this.dataKey ++
                }

            }
        }
    }

</script>
